<template>
  <b-container class="edit-setting">
    <b-form @submit.prevent="onSubmit">
      <div class="float-right">
        <b-button variant="default" @click="onFormCancel">
          Cancel
        </b-button>
        <b-button type="submit" variant="info">
          Save
        </b-button>
      </div>

      <h2>Edit Setting</h2>

      <b-form-group v-if="setting" label="Key:">
        <b-form-input id="input-1" v-model="key" disabled />
      </b-form-group>

      <b-form-group v-if="setting" label="Default:">
        <b-form-input id="input-1" v-model="defaultValue" disabled />
      </b-form-group>

      <component
        :is="componentName"
        :initial-value="value"
        @input="onInput"
        @valid="onValid"
      />
    </b-form>
    <v-wait for="loading">
      <HalfCircleSpinner slot="waiting" />
      <template slot="waiting">
        <div class="spinner-message my-3 text-center">
          Loading the setting...
        </div>
      </template>
    </v-wait>
  </b-container>
</template>

<script>
import Api from '@/providers/Api.js';
import { HalfCircleSpinner } from 'epic-spinners';
import SettingFieldString from './fields/SettingFieldString';
import SettingFieldNumber from './fields/SettingFieldNumber';
import SettingFieldUrl from './fields/SettingFieldUrl';
import SettingFieldEmail from './fields/SettingFieldEmail';
import SettingFieldBoolean from './fields/SettingFieldBoolean';
import SettingFieldJson from '@/components/settings/fields/SettingFieldJson';
import { SETTING_TYPES, UPDATE_SETTING_MUTATION } from '../../store';
import { SETTINGS_SIDE_ALL, SETTINGS_SIDE_FRONTEND } from './SettingsHelper';

export default {
  name: 'SettingEdit',
  components: {
    HalfCircleSpinner,
    SettingFieldString,
    SettingFieldNumber,
    SettingFieldUrl,
    SettingFieldEmail,
    SettingFieldBoolean,
    SettingFieldJson,
  },
  data() {
    return {
      setting: null,
      isValid: false,
    };
  },
  created() {
    this.$wait.start('loading');
    Api.getSetting(this, this.$route.params.key).then((s) => {
      this.setting = s;
      this.$wait.end('loading');
    });
  },
  computed: {
    value() {
      return this.setting ? this.setting.value : '';
    },
    key() {
      return this.setting ? this.setting.key : '';
    },
    defaultValue() {
      return this.setting ? this.setting.default : '';
    },
    componentName: function () {
      if (!this.setting) return null;
      switch (this.setting.type) {
        case SETTING_TYPES.STRING:
          return SettingFieldString.name;
        case SETTING_TYPES.INTEGER:
          return SettingFieldNumber.name;
        case SETTING_TYPES.BOOLEAN:
          return SettingFieldBoolean.name;
        case SETTING_TYPES.EMAIL:
          return SettingFieldEmail.name;
        case SETTING_TYPES.URL:
          return SettingFieldUrl.name;
        case SETTING_TYPES.JSON:
          return SettingFieldJson.name;
        default:
          return null;
      }
    },
  },
  methods: {
    onInput(data) {
      this.setting.value = data;
    },
    onValid(isValid) {
      this.isValid = isValid;
    },
    onSubmit: async function () {
      if (!this.isValid) {
        return;
      }

      try {
        await Api.updateSetting(this.setting.key, this.setting.value);
        this.$toasted.success('Setting saved successfully.', {
          duration: 3000,
        });

        this.updateStoreSettings();

        this.$router.push({ path: '/admin/settings' });
      } catch (error) {
        this.$toasted.error(error.response.data.message, { duration: 3000 });
      }
    },
    onFormCancel() {
      this.$router.go(-1);
    },
    updateStoreSettings() {
      if (
        [SETTINGS_SIDE_ALL, SETTINGS_SIDE_FRONTEND].includes(this.setting.side)
      ) {
        this.$store.commit(UPDATE_SETTING_MUTATION, {
          key: this.setting.key,
          value: this.setting.value,
        });
      }
    },
  },
};
</script>

<style scoped></style>
